import api from "./api";

// 系列课程商品列表
export const postEquipmentList = params => {
  return api("post", `/v1/management/equipment-series-of-course/list`, params);
};

// 根据名称或者SKU查询商品
export const getEquipmentBySku = sku => {
  return api("get", `/v1/management/equipment-series-of-course/equipmentBySku/${sku}`);
};

// 根据名称或者TagId查询商品
export const getEquipmentByTagId = id => {
  return api("get", `/v1/management/equipment-series-of-course/equipmentByTagId/${id}`);
};
// 导入系列课程商品名单
export const uploadEquipmentList = file => {
  const formData = new FormData();
  formData.append("file", file);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("post", `/v1/management/equipment-series-of-course/uploadEquipmentList`, formData, config);
};

// 系列课程商品管理列表
export const quipmentManagementList = params => {
  return api("get", `/v1/management/equipment-series-of-course/equipmentManagementList`, params);
};

// 保存商品
export const postEquipmentSave = params => {
  return api("post", `/v1/management/equipment-series-of-course/saveEquipment`, params);
};
